export { default } from './RecentlyReturnedIsDisabledContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedIsDisabledContentPanel/index.js